export const ExperimentsConsts = {
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  FormEditorKBContent: 'specs.bookings.FormEditorKBContent',
  MultiLocationUoU: 'specs.bookings.MultiLocationUoU',
  AddonsWithPlanOnlyUOU: 'specs.bookings.AddonsAndPlanOnlyUOU',
  CartConflictEnableSlotsTimezoneConversion:
    'specs.bookings.CartConflictEnableSlotsTimezoneConversion',
  UOUIntakeFormsIntegration: 'specs.bookings.UOUIntakeFormsIntegration',
  UseNewBenefitsAPIUoU: 'specs.bookings.UseNewBenefitsAPIUoU',
  AutomaticDiscountsUoU: 'specs.bookings.AutomaticDiscountsUoU',
  HandleMembershipErrorInCheckoutUoU:
    'specs.bookings.HandleMembershipErrorInCheckoutUoU',
  MoveToMetroMembershipSpiHostUoU:
    'specs.bookings.MoveToMetroMembershipSpiHostUoU',
  ShowUnavailableSlotForm: 'specs.bookings.ShowUnavailableSlotForm',
  TimezoneAwareSlotMatching: 'specs.bookings.TimezoneAwareSlotMatching',
};
